module.exports = __webpack_public_path__ + "img/1536343148.976a241a.jpg";